/* src/app/order/components/order-pricing/order-pricing.style.scss */
.product-pricing {
  margin-bottom: 40px;
}
.product-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.product-header h6.standard-name {
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.45;
  letter-spacing: normal;
  color: #007d40;
  margin-bottom: 0;
  margin-top: 0;
}
.product-header h6.standard-name:not(:first-child) {
  margin-top: 26px;
}
.product-header .toggle-view-section {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #007d40;
  cursor: pointer;
  text-decoration: none;
}
.product-header .toggle-view-section nb-icon {
  position: relative;
  top: 2px;
}
.pricing-changed-info {
  color: #ee7f00;
  margin: 0 0 20px 0;
}
.hide-section {
  display: none;
}
/*# sourceMappingURL=order-pricing.style.css.map */
